import QueryString from "query-string";
import { useMemo } from "react";
import { useLocation } from "react-router";

export function useQueryParams() {
    const location = useLocation();
    const query = useMemo(() => QueryString.parse(location.search), [location.search]);
    return query;
}
